import ListItemCardCst from "@components/ListItemCardCst";
import { useFetchTable } from "@hooks/useFetchDataTable";
import { ServicesURL } from "@utils/utilsApi";
import { TriangleAlert } from "lucide-react";
import { useParams } from "react-router-dom";

const USERS_URL = ServicesURL.users;

export default function UsersPanel() {
  const { id: corporateId = "" } = useParams();
  const { dataTable } = useFetchTable(USERS_URL, undefined, {
    pageIndex: "0",
    pageSize: "6",
    corporateId,
  });

  return (
    <ListItemCardCst
      title="Nome e Cognome"
      subtitle={{ id: "1234", email: "nome@example.com", groupId: "1234" }}
      badges={[
        { label: "Auto iscrizione" },
        { variant: "warning", icon: <TriangleAlert />, label: "" },
      ]}
      details={{
        row1: "Data di completamento: -",
        row2: "Data di scadenza",
      }}
      actions={[
        {
          label: "Dettagli",
          variant: "outlined",
          onClick: () => {},
        },
      ]}
    />
  );
}
